import React, {useState} from "react";
import {DownOutlined} from "@ant-design/icons";
import {Button, ButtonVariants, Text, TextAs, TextSizes} from "@clockout-dev/design-elements";
import SectionCard from "../../common/sectionCard/SectionCard";
import pillStyles from "../styles/pills.module.scss";
import styles from "../styles/sor-composer.module.scss";

/**
 * Collapsible composer section: `SectionCard` shell + a completion badge and
 * a collapse chevron in the header action slot. Collapse state is purely
 * local UI state (hooks pattern per AI-START-HERE) — the SOR values live in
 * the page controller regardless of what is folded away.
 *
 * @param {Object} props
 * @param {JSX.Element} [props.icon]
 * @param {string} props.title
 * @param {boolean} [props.filled] — drives the FILLED/EMPTY badge
 * @param {boolean} [props.defaultCollapsed]
 * @param {React.ReactNode} props.children
 */
function ComposerSection({icon, title, filled = false, defaultCollapsed = false, children}) {
    const [collapsed, setCollapsed] = useState(defaultCollapsed);

    return (
        <SectionCard
            icon={icon}
            title={title}
            action={
                <div className={styles.sectionActions}>
                    <Text as={TextAs.SPAN} size={TextSizes.EXTRA_SMALL} className={`${pillStyles.tag} ${filled ? pillStyles.tone_success : pillStyles.tone_neutral}`}>
                        {filled ? "Filled" : "Empty"}
                    </Text>
                    <Button
                        variant={ButtonVariants.TEXT}
                        className={styles.collapseButton}
                        aria-label={collapsed ? `Expand ${title}` : `Collapse ${title}`}
                        onClick={() => setCollapsed(previous => !previous)}>
                        <DownOutlined className={collapsed ? styles.chevronCollapsed : styles.chevron} />
                    </Button>
                </div>
            }>
            {collapsed ? null : <div className={styles.sectionBody}>{children}</div>}
        </SectionCard>
    );
}

export default ComposerSection;
